import React, {useState, useEffect, useContext} from "react";
import { Outlet, Link } from "react-router-dom";
import useAxiosIntercept from "../../../hooks/useAxiosIntercept";
import NavFooter from "../SideBar/NavFooter";
import NavList from "./NavList";
import navContext from "../../../context/navContext";



const NavBar = () => {
  // const [navData, setNavData] = useState(null);
  const axiosPrivate = useAxiosIntercept();
  const {nav, setNav} = useContext(navContext);
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getNavData = async () => {
      try {
        const response = await axiosPrivate.get(
            process.env.REACT_APP_GET_MENU_LINKS,
            {
              signal: controller.signal,
            }
        );
        return response?.data?.response?.data?.menu_links;
        // isMounted && setNavData(response?.data);
      } catch (err) {
        //console.error(err);
      }
    };
    if(nav?.length == 0 || nav == undefined){
      getNavData().then((data)=>{
        setNav(data);
      })
    }

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);
  return (
      <>
        <div className="main_navigation">
          <ul>

            {nav && (
                <NavList navigationList={nav} />
            )}

          </ul>
          <NavFooter />
        </div>

        <Outlet />
      </>
  );
};

export default NavBar;
